export default "__VITE_ASSET__bb6381a3__"